import { render, staticRenderFns } from "./AdaButton.vue?vue&type=template&id=0cd71a6f&scoped=true"
import script from "./AdaButton.vue?vue&type=script&lang=js"
export * from "./AdaButton.vue?vue&type=script&lang=js"
import style0 from "./AdaButton.vue?vue&type=style&index=0&id=0cd71a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd71a6f",
  null
  
)

export default component.exports